import reducer from './reducers';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';

export const createWithInitialState = state =>
  createStore(reducer, state, applyMiddleware(thunk));
